import { render, staticRenderFns } from "./vendors_name.vue?vue&type=template&id=4ea5d2b2&scoped=true&"
import script from "./vendors_name.vue?vue&type=script&lang=js&"
export * from "./vendors_name.vue?vue&type=script&lang=js&"
import style0 from "./vendors_name.vue?vue&type=style&index=0&id=4ea5d2b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5d2b2",
  null
  
)

export default component.exports